import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapSquareFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.75 10.31L10.86 8.27L8.6 20.25H8.28C7.86 20.25 7.46 20.2 7.1 20.1L9.39 7.97L4.35 6.93C4.46 6.4 4.64 5.92 4.9 5.51L10.37 6.64H10.4C10.42 6.65 10.44 6.65 10.45 6.66L20.75 8.78V10.31ZM15.12 18.65C14.31 18.65 11.95 16.5 11.95 14.42C11.95 12.67 13.37 11.24 15.12 11.24C16.88 11.24 18.3 12.67 18.3 14.42C18.3 16.5 15.94 18.65 15.12 18.65ZM16.72 2.25H8.28C5.76 2.25 3.87 3.6 3.12 5.77C3.1 5.81 3.09 5.86 3.08 5.9C2.86 6.54 2.75 7.26 2.75 8.03V15.97C2.75 19.15 4.63 21.37 7.5 21.7C7.52 21.7 7.54 21.71 7.56 21.71C7.61 21.72 7.66 21.73 7.7 21.73C7.72 21.73 7.75 21.73 7.77 21.72C7.94 21.74 8.11 21.75 8.28 21.75H16.72C20.03 21.75 22.25 19.43 22.25 15.97V8.03C22.25 4.57 20.03 2.25 16.72 2.25Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.118 13.498C14.625 13.498 14.229 13.894 14.229 14.399V14.435C14.229 14.928 14.625 15.312 15.118 15.312C15.623 15.312 16.031 14.892 16.031 14.399C16.031 13.894 15.623 13.498 15.118 13.498Z",
		fill: "currentColor"
	})]
});
export default SvgMapSquareFill;
